import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {useFilters} from '../../components/filters';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls, normalizeRuStr} from '../../components/utils';
import {Feat, useFeatsQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {FeatView} from './view';
import {featCategoryToString} from '../../components/enums';
import {getAllTitles} from '../../components/render-helpers';
import {FeatFilters, featFilters} from './filters';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const FeatsPage: React.FC<Props> = () => {
	const filters = useFilters(featFilters);

	const router = useRoute();
	const query = router?.query || {};

	const {data, loading, error} = useFeatsQuery({
		ssr: true,
		variables: {filters: filters.values},
	});

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.feats || [],
		id: query.id as string,
		loading,
		route: 'feat',
		baseRoute: 'feats',
		sidebarHeader: (feat) => feat.title,
		sidebarSecondary: (feat) => featCategoryToString(feat.category),
		filterFn: (feat, str) => {
			const names = getAllTitles(feat as Feat);
			return names.some((name) => normalizeRuStr(name).includes(normalizeRuStr(str)));
		},
		onOpenFilters: filters.toggle,
		isFiltersSet: filters.isSet,
	});

	const title = showView && selected ? selected.title : 'Черты';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="feats" />}
			{notFound && <NotFoundSeo />}
			<FeatFilters filters={filters} />
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<FeatView featId={selectedId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите черту</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
